<!-- Outline only. Everything editable lives in the side panel. -->
<div class="highlight" *ngIf="picking && highlight"
  [style.top.px]="highlight.top" [style.left.px]="highlight.left"
  [style.width.px]="highlight.width" [style.height.px]="highlight.height">
  <span class="highlight-hint" *ngIf="hoveredLabels.length">
    {{ ("commons.themeConfiguration.colors." + hoveredLabels[0]) | translate }}
    <em *ngIf="hoveredLabels.length > 1">+{{ hoveredLabels.length - 1 }}</em>
  </span>
</div>
